import { Modal, message } from 'antd';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PurchaseModalRender from './children/PurchaseModalRender';
import { accountList } from '@/constants/url';
import actions from '@/action';
import '../../../assets/purchaseModal.scss';
import { requsetGetPurchase, requsetGetSubscription } from '@/api/apis';
import {
  GAPurchaseModalVisibleBySizeLimit,
  GAPurchaseModalVisibleByTimesLimit,
} from '@/ga/purchase';
import sentGAEvent from '@/ga';
import Utils from '../../../utils/utils';

class PurchaseModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      signUpUrl: accountList.get('accountLoginPage'),
      enterCodeInputVisible: false,
      visible: false,
      loading: false,
    };
    this.timer = null;
  }

  componentDidMount() {
    //埋点
    if (this.props.purchaseModalObj.type === 'uploadSizeBiggerThanLimit') {
      GAPurchaseModalVisibleBySizeLimit();
    } else {
      GAPurchaseModalVisibleByTimesLimit();
    }
  }

  componentWillUnmount() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  /**
   * 控制当前套餐
   * @param {Boolean} checked 控制当前套餐
   */
  handleEnterCodeInputVisibleChange = (enterCodeInputVisible) => {
    this.setState({
      enterCodeInputVisible,
    });
  };

  /**
   * 控制当前套餐
   * @param {Boolean} checked 控制当前套餐
   */

  /**
   * 轮询订阅信息
   */
  handleListenerSubscription = () => {
    this.timer = setInterval(() => {
      requsetGetSubscription()
        .then((res) => {
          if (res.code === 200) {
            if (
              res.data.subscription &&
              res.data.subscription[0].status === 'Active' &&
              (!this.props.subscription ||
                (this.props.subscription &&
                  this.props.subscription.status === 'Expired'))
            ) {
              console.log('监听到了用户已经购买');
              this.props.onPurchaseModalObjChange({
                ...this.props.purchaseModalObj,
                visible: false,
              });
            }
            this.props.onSubscriptionChange(res.data.subscription[0]);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }, 12000);
  };

  /**
   * 请求购买链接
   */
  getPurchase = (plan) => {
    this.setState({
      loading: true,
    });
    let site = Utils.getLanguage();

    const formData = new FormData();
    formData.append('plan', plan);
    formData.append('site', site);
    requsetGetPurchase({
      body: formData,
    })
      .then((res) => {
        console.log(res);
        this.setState({
          loading: false,
        });
        if (res.code === 200) {
          //轮询监听用户购买
          //  this.handleListenerSubscription()
          //购物车地址
          let cartUrl = res.data.cart_url;
          setTimeout(() => {
            //在哪个功能弹窗的
            let func;
            let currWork = localStorage.getItem('currWork');
            if (!currWork) {
              func = 6;
            }
            if (currWork == 'removeWatermark') {
              func = 7;
            }
            if (currWork == 'addWatermark') {
              func = 8;
            }
            if (currWork == 'speed') {
              func = 9;
            }
            if (currWork == 'reverse') {
              func = 10;
            }
            if (currWork == 'cut') {
              func = 11;
            }
            if (currWork == 'addMusic') {
              func = 12;
            }
            if (currWork == 'subtitle') {
              func = 13;
            }
            if (currWork == 'resize') {
              func = 14;
            }
            if (currWork == 'crop_rotate') {
              func = 15;
            }
            if (currWork == 'loop') {
              func = 16;
            }
            if (currWork == 'merge') {
              func = 17;
            }

            //为啥弹窗
            let reason;
            if (
              this.props.purchaseModalObj.type === 'uploadSizeBiggerThanLimit'
            ) {
              reason = 1;
            } else {
              reason = 2;
            }

            //host 语言
            let host;
            let langMap = [
              'en',
              'de',
              'es',
              'fr',
              'it',
              'br',
              'jp',
              'kr',
              'ar',
              'nl',
              'id',
              'inn',
              'tr',
              'ru',
              '泰文',
              'tw',
              '中简',
            ];
            host = langMap.indexOf(Utils.getLanguage());
            //用户设备平台
            let platform;
            let SystemType = Utils.getSystemType();
            if (SystemType == 'iOS') {
              platform = 3;
            }
            if (SystemType == 'Android') {
              platform = 4;
            }
            if (SystemType == 'Win') {
              platform = 2;
            }
            if (SystemType == 'Mac') {
              platform = 1;
            }
            if (SystemType == 'Other') {
              platform = 5;
            }
            // 年月
            let cycle = plan == 'month' ? 2 : 3;

            // 渠道来源
            let source = localStorage.getItem('toolsSource');

            cartUrl =
              cartUrl +
              '&track[type]=4&track[sid]=116' +
              `&track[func]=${func}&track[reason]=${reason}&track[host]=${
                host + 1
              }&track[platform]=${platform}&track[cycle]=${cycle}&track[ab]=0Z&track[channel]=${source}&track[discount]=0`;
            console.log('cartUrl:', cartUrl);
            window.open(cartUrl, '_blank');
            let gacurrWork = localStorage.getItem('currGa');
            sentGAEvent({
              category: 'BuyNow',
              action: gacurrWork + '_BuyNow',
            });
          }, 300);
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          loading: false,
        });
      })
      .finally(() => {
        this.setState({
          loading: false,
        });
      });
  };

  handleSentCode = (e) => {
    e.stopPropagation();
    message.warn(window.i18n.t('purchase:promoCodeInvalidTips'));
  };

  handleCancelSubscribe = (purchaseModalObj) => {
    this.props.onPurchaseModalObjChange({
      ...purchaseModalObj,
      visible: false,
    });
    sentGAEvent({
      category: 'Subscribe',
      action: 'SubscribePrompt_Close_Click',
    });
  };

  render() {
    const {
      purchaseModalObj,
      authorization,
      work,
      onPayBill,
      onPurchaseModalObjChange,
    } = this.props;
    return (
      <>
        <PurchaseModalRender
          enterCodeInputVisible={this.state.enterCodeInputVisible}
          handleEnterCodeInputVisibleChange={
            this.handleEnterCodeInputVisibleChange
          }
          loading={this.state.loading}
          signUpUrl={this.state.signUpUrl}
          purchaseType={!this.props.profileObj ? 'account' : 'cartUrl'}
          getPurchase={this.getPurchase}
          purchaseModalObj={purchaseModalObj}
          onPurchaseModalObjChange={onPurchaseModalObjChange}
          work={work}
          onPayBill={onPayBill}
          authorization={authorization}
          handleSentCode={this.handleSentCode}
        />
      </>
    );
  }
}

const mapStateToPropos = (state) => ({
  work: state.work.work,
  purchaseModalObj: state.common.purchaseModalObj,
  profileObj: state.common.profileObj,
  subscription: state.common.subscription,
  authorization: state.common.authorization,
});
const mapDispatchToProps = (dispatch) => ({
  onPurchaseModalObjChange: (purchaseModalObj) =>
    dispatch(actions.onPurchaseModalObjChange(purchaseModalObj)),
  onSubscriptionChange: (subscription) =>
    dispatch(actions.onSubscriptionChange(subscription)),
  onPayBill: (visible) => dispatch(actions.onPayBill(visible)),
});

export default connect(mapStateToPropos, mapDispatchToProps)(PurchaseModal);
